import { graphql } from "~/gql";

export const DELETE_TECHNOLOGY_CHARGE = graphql(/* GraphQL */ `
  mutation deleteTechnologyCharge($technologyChargeId: Float!) {
    deleteTechnologyCharge(technologyChargeId: $technologyChargeId) {
      technologyChargeId
    }
  }
`);
